import { InputFormCallout, InputFormCalloutProps, TextInput, TextInputTypes, uniqueGUID } from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { CalloutTestIds } from "../../constants/uiConstants";

export interface UpdatePasswordProps extends
  Pick<InputFormCalloutProps, "targetId" | "onClose" | "onSubmit" | "componentRef">
{
  title?: string;
  tooltip?: string;
  validator?: (value: string) => string[] | undefined;
  passwordLabel?: string;
  confirmPasswordLabel?: string;
  oldPassword?: {
    label: string;
    tooltip?: string;
  }
}

export enum Fields {
  OldPassword = "OldPassword",
  Password = "Password",
  ConfirmPassword = "ConfirmPassword",
}

export enum FieldsTestIds {
  OldPassword = "old-password",
  Password = "password",
  ConfirmPassword = "confirm-password",
}

export const UpdatePassword = (
  {
    targetId,
    onClose,
    onSubmit,
    componentRef,
    tooltip = Messages.hints.tooltipAdminPassword(),
    validator,
    passwordLabel = Messages.labels.newAdminPassword(),
    confirmPasswordLabel = Messages.labels.newAdminConfirmPassword(),
    title = Messages.createNewPanels.changePassword.title(),
    oldPassword,
  }: UpdatePasswordProps,
): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [oldWalletPassword, setOldWalletPassword] = React.useState<string>();
  const [adminPassword, setAdminPassword] = React.useState<string>();
  const [confirmPassword, setConfirmPassword] = React.useState<string>();
  const [confirmPassWordKey, setConfirmPasswordKey] = React.useState<string>(uniqueGUID());
  const onChangePassword = (value: string): void => {
    setAdminPassword(value);
    if (confirmPassword !== undefined) {
      setConfirmPasswordKey(uniqueGUID());
    }
  };

  return (

    <InputFormCallout
      componentRef={componentRef}
      title={title}
      targetId={targetId}
      onSubmit={onSubmit}
      onClose={onClose}
      testId={CalloutTestIds.UpdatePassword}
    >
      <>
        {oldPassword && (
          <TextInput
            testId={FieldsTestIds.OldPassword}
            required
            fieldName={Fields.OldPassword}
            label={oldPassword.label}
            textType={TextInputTypes.PASSWORD}
            onChange={value => { setOldWalletPassword(value); }}
          />
        )}
        <TextInput
          testId={FieldsTestIds.Password}
          required
          fieldName={Fields.Password}
          label={passwordLabel}
          tooltip={tooltip}
          textType={TextInputTypes.PASSWORD}
          onChange={value => { onChangePassword(value); }}
          validator={validator}
        />
        <TextInput
          testId={FieldsTestIds.ConfirmPassword}
          key={confirmPassWordKey}
          required
          fieldName={Fields.ConfirmPassword}
          label={confirmPasswordLabel}
          textType={TextInputTypes.PASSWORD}
          onChange={value => { setConfirmPassword(value); }}
          validator={(value: string) => {
            if (value && (value !== adminPassword)) {
              return [Messages.validation.passwordConfirmation()];
            }
            return undefined;
          }}
        />
      </>
    </InputFormCallout>

  );
};
